<template>
  <div>
    <HeadlineContainer headline="Partnership Activity Mails" :breadcrumbs="[{text: 'Partnership Activity Mails'}]"/>

    <div v-if="!loading" class="container">
      <PartnershipActivityMailList :portals="portals"/>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import PartnershipActivityMailList from '../../../components/Relations/PartnershipActivityMails/Panels/List'
import HeadlineContainer from '@/components/Layout/HeadlineContainer'

export default {
  components: {PartnershipActivityMailList, HeadlineContainer},

  data() {
    return {
      portals: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      this.loading = true

        http.get('/api/v2/portals', {page_size: 100}).then(response => {
        this.portals = response.data.data

        this.loading = false
      })
    }
  }
}
</script>
